export default __webpack_public_path__ + "static/media/Background.c6e469e0.jpg";